import { createContext } from 'react';

var noop = function() {
    return undefined;
};
var SuggestionContext = /*#__PURE__*/ createContext({
    onClickSuggestionItem: noop,
    onDismissSuggestions: noop,
    onFirstSuggestionKeyDown: noop,
    onRemoveHistoryItem: noop
});

export { SuggestionContext as default };
